function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.78 20.98A5.436 5.436 0 0112 22.51c-1.36 0-2.72-.52-3.78-1.54-.36-.34-.72-.72-1.08-1.11l12.9-12.9c.25.54.44 1.11.58 1.74 1.17 5.16-1.99 9.52-4.84 12.28zm5.99-18.75c-.3-.3-.79-.3-1.09 0L2.23 20.69c-.3.3-.3.79 0 1.09a.758.758 0 001.08-.01L21.77 3.31c.31-.3.31-.78 0-1.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.85 10.31a3.15 3.15 0 016.06-1.21l3.98-3.98C17.12 2.98 14.44 2 12 2c-1.77 0-3.66.52-5.24 1.61-1.58 1.1-2.86 2.77-3.38 5.08-.84 3.67.52 6.95 2.41 9.52l5-5a3.144 3.144 0 01-1.94-2.9z"
})));